module.exports = __webpack_public_path__ + "media/custom/images/img1-de5f6289460febb166d6e391252766db.png";